import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { DeviceType, AppModule } from '@/store/modules/app';
import { SettingsModule } from '@/store/modules/settings';
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components';
import RightPanel from '@/components/RightPanel/index.vue';
import ResizeMixin from './mixin/resize';
var default_1 = /*#__PURE__*/function (_mixins) {
  function default_1() {
    _classCallCheck(this, default_1);
    return _callSuper(this, default_1, arguments);
  }
  _inherits(default_1, _mixins);
  return _createClass(default_1, [{
    key: "classObj",
    get: function get() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === DeviceType.Mobile
      };
    }
  }, {
    key: "showSettings",
    get: function get() {
      return SettingsModule.showSettings;
    }
  }, {
    key: "showTagsView",
    get: function get() {
      return SettingsModule.showTagsView;
    }
  }, {
    key: "fixedHeader",
    get: function get() {
      return SettingsModule.fixedHeader;
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      AppModule.CloseSideBar(false);
    }
  }]);
}(mixins(ResizeMixin));
default_1 = __decorate([Component({
  name: 'Layout',
  components: {
    AppMain: AppMain,
    Navbar: Navbar,
    RightPanel: RightPanel,
    Settings: Settings,
    Sidebar: Sidebar,
    TagsView: TagsView
  }
})], default_1);
export default default_1;